interface HowPointsWorkProps {
  onBack: () => void;
  onNavigate: (screen: 'points-activity') => void;
}

const CARDS = [
  {
    title: 'Earn while you host',
    body: 'Tokens add up as you host. Stay available, run sessions, and watch your balance grow over time.',
  },
  {
    title: 'Redeem when you\u2019re ready',
    body: 'Browse the catalog and redeem rewards with your tokens. Save up for something bigger, or grab a card as soon as you hit the threshold.',
  },
  {
    title: 'Plenty of time to redeem',
    body: 'Tokens expire a year after earning them. Keep hosting to stay ahead \u2014 and check Tokens activity anytime for the full picture.',
  },
  {
    title: 'Rewards availability',
    body: 'Popular rewards can sell out. When something\u2019s unavailable, check back after restocks.',
  },
];

export const HowPointsWork = ({ onBack, onNavigate }: HowPointsWorkProps) => {
  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      {/* Back row */}
      <button type='button' onClick={onBack}
        className='mb-3 shrink-0 self-start border-none bg-transparent p-0 text-sm font-semibold text-[#FFFFFF]/90 transition-opacity hover:opacity-80'>
        &larr; Settings
      </button>
      <p className='shrink-0 text-[18px] font-semibold text-white' style={{ marginBottom: 8 }}>How tokens work</p>

      {/* Scrollable content */}
      <div className='hr-scroll min-h-0 flex-1 overflow-y-auto' style={{ paddingRight: 4 }}>
        <div className='flex flex-col gap-3 pb-3'>
          {/* Intro */}
          <div>
            <p className='text-[20px] font-semibold text-[#FBBF24]' style={{ letterSpacing: '-0.02em' }}>
              Host. Earn. Redeem.
            </p>
            <p className='text-[13px] text-[#FFFFFF]/90' style={{ marginTop: 8, lineHeight: 1.5 }}>
              Keep your machine online for Playcast sessions and earn tokens toward Steam gift cards and
              more.
            </p>
          </div>

          {/* Cards */}
          {CARDS.map((card) => (
            <div
              key={card.title}
              style={{ padding: 12, borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.05)' }}
            >
              <p className='text-[13px] font-semibold text-white' style={{ marginBottom: 4 }}>{card.title}</p>
              <p className='text-[13px] text-[#FFFFFF]/90' style={{ lineHeight: 1.5 }}>{card.body}</p>
            </div>
          ))}

          {/* Footer links */}
          <button type='button' onClick={() => onNavigate('points-activity')}
            className='w-full border-none bg-transparent p-0 text-center text-[12px] text-[#FFFFFF]/90 underline transition-opacity hover:opacity-80'>
            Tokens activity
          </button>

          <a
            href='https://playcast.io/terms-of-service/'
            target='_blank'
            rel='noopener noreferrer'
            className='mb-2 block w-full text-center text-[10px] text-[#FFFFFF]/60 underline transition-opacity hover:opacity-80'
          >
            Host Program Terms of Service
          </a>
        </div>
      </div>
    </div>
  );
};
